import "jquery";
import "jquery.cookie";
import "bootstrap"; //Include bootstrap here to ensure that it is included.

export class Global {
    private initBootstrap(): void {
        //inits tooltips
        $('[data-toggle="tooltip"]').tooltip();

        //Init popovers
        $('[data-toggle="popover"]').popover({});

    }

    init(): void {
        this.initBootstrap();
    }
}